var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriteFail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11930_3336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 1.74967H8.64498C8.39998 1.07301 7.75831 0.583008 6.99998 0.583008C6.24165 0.583008 5.59998 1.07301 5.35498 1.74967H2.33331V12.833H7.06415C6.71998 12.5005 6.20414 12.1038 5.99998 11.6663H3.49998V2.91634H4.66665V4.66634H9.33331V2.91634H10.5V4.14951C10.9141 4.20785 11.305 4.33035 11.6666 4.49951V1.74967ZM6.99998 2.91634C6.67915 2.91634 6.41665 2.65384 6.41665 2.33301C6.41665 2.01217 6.67915 1.74967 6.99998 1.74967C7.32081 1.74967 7.58331 2.01217 7.58331 2.33301C7.58331 2.65384 7.32081 2.91634 6.99998 2.91634Z",
    fill: "#D31759"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13C12.2091 13 14 11.2091 14 9C14 6.79086 12.2091 5 10 5C7.79086 5 6 6.79086 6 9C6 11.2091 7.79086 13 10 13ZM10.8684 9L12 7.86847L11.1315 7L9.99988 8.13153L8.86852 7.00024L8 7.8687L9.13136 9L8 10.1313L8.86852 10.9998L9.99988 9.86847L11.1315 11L12 10.1315L10.8684 9Z",
    fill: "#D31759"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11930_3336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteFail);
export default __webpack_public_path__ + "static/media/write-fail.405464c1710e02f10f26af72c9f1b157.svg";
export { ForwardRef as ReactComponent };